import type { Tracker } from '@archipro-website/tracker';

/** Which library tile was clicked, reported as the event's content type. */
export type TrackTileMediaItemType =
    | 'ProductTile'
    | 'ProfessionalTile'
    | 'ProjectTile'
    | 'ArticleTile';

interface TrackTileMediaProps {
    itemID: number;
    itemType: TrackTileMediaItemType;
    itemName: string;
}

/**
 * Track the `TileMediaDetailClick` event. Triggers when a user clicks on a tile
 * to go to the detail page.
 */
export function trackTileMediaDetailClick(
    tracker: Tracker,
    props: TrackTileMediaProps,
) {
    void tracker.log('TileMediaDetailClick', {
        url: new URL(window.location.href),
        label: props.itemName,
        data: {
            LibraryItemID: props.itemID,
            content_ids: [`${props.itemType}_${props.itemID}`],
            content_type: props.itemType,
        },
        targetTracker: ['archiproTracker', 'ga4Tracker'],
    });
}
